export var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["config"] = "ECDConfig";
    LocalStorageKeys["user"] = "ECDUser";
    LocalStorageKeys["theme"] = "ECDTheme";
    LocalStorageKeys["practitionerProfilePicture"] = "PractitionerProfilePicture";
})(LocalStorageKeys || (LocalStorageKeys = {}));
//# sourceMappingURL=local-storage-keys.js.map